// src/client/auth/AuthContext.tsx
import { createContext } from 'react';
import type { Session, User } from '@supabase/supabase-js';
import type { BorrowerFixture } from '@client/lib/fixtures';

export interface ClientAuthContextValue {
  session: Session | null;
  user: User | null;
  profile: BorrowerFixture | null;
  status: 'loading' | 'signed_out' | 'signed_in';
  signOut: () => Promise<void>;
  refresh: () => Promise<void>;
  deleteAccount: () => Promise<{ ok: boolean; error?: string }>;
}

export const AuthContext = createContext<ClientAuthContextValue | null>(null);
